import { helpers } from '@vuelidate/validators';
import { unref } from 'vue-demi';
function mustBeEqual(other, message) {
    return helpers.withMessage(message, (val) => !helpers.req(val) || unref(other) === val);
}
export default mustBeEqual;
